module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-06-9a09ae2b6e1f7dfafa193ce99e99bfeb.webp";